import React from "react";

const SuonaConNoi = () => {
  return (
    <div className="flex flex-col items-center z-10">
      <p className="text-red-600 font-extrabold xs:text-2x1 md:text-3xl">
        SUONA CON NOI
      </p>
      <div className="flex flex-col w-2/3 items-center xs:text-base md:text-2xl">
        <p className="mt-6">Vieni a suonare con noi!</p>
        <p className="flex text-center mt-6 ">
          Le prove della NUOVA ORCHESTRA DI MILANO sono tutti i mercoledì sera
          presso la parrocchia di S. Luigi Gonzaga a Milano, via Don Bosco 10
        </p>
        <p className="flex flex-col text-center mt-6 ">
          {" "}
          Per informazioni:
          <a href="mailto: info@milarte.it">info@milarte.it</a>
          <a href="mailto: milarte.mi@pec.it"> milarte.mi@pec.it</a>
        </p>
        <p className="flex text-center mt-6">
          Le prove di MILANO Wind Ensemble sono 2 volte al mese il martedì sera
          presso la Villa Scheibler MILANO, via Felice Orsini 21
        </p>
        <p>
          <a href="https://www.giuseppedinardo.it/">Giuseppe Dinardo :</a>
          <p>+39 338 830 3778</p>
        </p>
      </div>
    </div>
  );
};

export default SuonaConNoi;
